import React, { useState, useEffect, useRef, useMemo } from 'react';
import JoditEditor from "jodit-react";
import { useParams , useNavigate } from 'react-router-dom';
import { ProtectAPi } from '../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../tools/BackButton';

const CaseEdit = () => {
  const { http } = ProtectAPi();
  const editor = useRef(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const [loader, setLoader] = useState('off');
  const [caseCategory, setCaseCategory] = useState('');
  const [caseTitle, setCaseTitle] = useState('');
  const [caseSlug, setCaseSlug] = useState('');
  const [caseDescription, setCaseDescription] = useState('');

  const [caseCategoryError, setCaseCategoryError] = useState('');
  const [caseTitleError, setCaseTitleError] = useState('');
  const [caseSlugError, setCaseSlugError] = useState('');
  const [caseDescriptionError, setCaseDescriptionError] = useState('');

  useEffect(() => {
    http.get(`/edit-case-study/${id}`)
      .then(res => {
        const { category, title, slug, description } = res.data;
        setCaseCategory(category);
        setCaseTitle(title);
        setCaseSlug(slug);
        setCaseDescription(description);
      })
      .catch(error => {
        console.error('Error fetching case details:', error);
      });
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'caseCategory') {
      setCaseCategory(value);
    } else if (name === 'caseTitle') {
      setCaseTitle(value);
    } else if (name === 'caseSlug') {
      setCaseSlug(value);
    }
  };

  const submitForm = () => {
    setLoader('on');
    const formData = new FormData();
    formData.append('id', id);
    formData.append('category', caseCategory);
    formData.append('title', caseTitle);
    formData.append('slug', caseSlug);
    formData.append('description', caseDescription);

    http.post(`/update-case-study/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    }).then(res => {
      if (res.data.status === '422') {
        const errors = res.data.error;
        setLoader('off');
        setCaseCategoryError(errors.category ? errors.category[0] : '');
        setCaseTitleError(errors.title ? errors.title[0] : '');
        setCaseSlugError(errors.slug ? errors.slug[0] : '');
        setCaseDescriptionError(errors.description ? errors.description[0] : '');
      } else {
        setLoader('off');
        swal('Success', res.data.msg, 'success').then(() => {
          navigate('/admin/pages/case-study-list');
        });
      }
    }).catch(error => {
      console.error('Error:', error);
      setLoader('off');
    });
  };

  const placeholder = 'Start typing...';
  const editorConfig = useMemo(() => ({
    readonly: false,
    placeholder: placeholder || 'Start typing...',
    uploader: {
      insertImageAsBase64URI: true
    },
    height: 300
  }), [placeholder]);

  return (
    <div>
      <div className="main-content">
        <section className="section">
          <div className="section-body">
            <div className="row">
              <div className="col-12">
                <div className="card card-primary">
                  <div className="card-body">
                    <div className="d-flex justify-content-between">
                      <h5>Edit Case</h5>
                      <BackButton />
                    </div>
                    <div className="card-body pb-0">
                      <div className="row mb-3">
                        <div className="col-md-12">
                          <label>Case Study Category</label>
                          <input type="text" id="caseCategory" name="caseCategory" value={caseCategory} className="form-control" placeholder='Case category' onChange={handleInputChange} />
                          <span className='text-danger'>{caseCategoryError}</span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <label>Case Study Title</label>
                          <input type="text" id="caseTitle" name="caseTitle" value={caseTitle} className="form-control" placeholder='Case title' onChange={handleInputChange} />
                          <span className='text-danger'>{caseTitleError}</span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <label>Slug (Optional)</label>
                          <input type="text" id="caseSlug" name="caseSlug" value={caseSlug} className="form-control" placeholder='Case slug' onChange={handleInputChange} />
                          <span className='text-danger'>{caseSlugError}</span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <label>Case Description</label>
                            <JoditEditor
                              ref={editor}
                              value={caseDescription}
                              config={{ 
                                ...editorConfig, 
                                height: 400 
                              }}
                              tabIndex={1}
                              onBlur={newContent => setCaseDescription(newContent)}
                              onChange={() => { }}
                            />

                          <span className='text-danger'>{caseDescriptionError}</span>
                        </div>

                        <div className="cil-md-12 mt-5">
                          {loader === 'off' ? (
                            <button type="submit" onClick={submitForm} className="btn btn-lg btn-primary">Update</button>
                          ) : (
                            <div className="spinner-border text-dark" role="status"></div>
                          )}
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default CaseEdit;
